<template>

<div class="el-divider el-divider--horizontal" :style="{margin: marginPx}"><div class="el-divider__text text-primary is-left">{{title}}

</div><div v-if="$store.state.operate=='详情'"  class="el-divider__text is-center">
<!-- <template v-if="isButton">
<el-tooltip class="item" effect="dark" :content="!value?'编辑':'取消'" placement="top">
<div @click="openEditClick" :class="!value?'el-icon-edit':'el-icon-close'" class=" pointer"  style="border-radius: 50%!important;padding: 12px!important;border: 1px solid #dcdfe6;color: #606266;" ></div>
    </el-tooltip>
	</template> -->
</div>

</div>
	  </template>
<script>
	  export default {
		      props: {
				value: {
					type: String,
					default: ''
				},
		      	title: {
		      		type: String,
		      		default: ''
		      	},
				// isButton: {
		  //     		type: Boolean,
		  //     		default: true
		  //     	},
				isButton: {
					type: Boolean,
					default: false
				},
				marginPx: {
					type: String,
					default: '40px 0'
				}
		      },  
			  computed:{
				  
			  },
	    data() {
	      return {
			 }
	    },
	  methods:{
		  openEditClick(){
		  this.$emit("input",this.value?"":this.title)
	  }
	  }
	  }
</script>

<style>
</style>
